import { Badge, Button, Container, CopyToClipboard, Header, Link, SpaceBetween } from '@cloudscape-design/components';
import { useRumClickEvent } from '../utils/rum';
import '@cloudscape-design/global-styles/index.css';
import { DemoDefinition, DemoStatus } from '../types';
import GitHubIcon from '@mui/icons-material/GitHub';
import DemoStatusIndicator from '../components/DemoStatusIndicator';


export default function DemoDetails({ name, path, demoDetails, description, status }: DemoDefinition) {
    const recordRumClick = useRumClickEvent();


    return (
        <SpaceBetween key="space-main" direction='vertical' size='m'>
            <Container key="main-demo-container">
                <SpaceBetween key="space-sub-main" direction='vertical' size='m'>
                    <SpaceBetween key="space-main-header" direction='vertical' size='xxxs'>
                        <Header key="main-demo-header" variant='h1' description={description}>
                            {name}
                        </Header>
                        {status ? (
                            <DemoStatusIndicator status={status} />
                        ) : null}
                    </SpaceBetween>
                    <SpaceBetween direction="horizontal" size="m">
                        {status === DemoStatus.comingSoon ? (
                            <Button key="coming-soon-button" variant='primary' disabled>
                                Coming Soon
                            </Button>
                        ) : (
                            <Button key="main-demo-button" variant='primary' onClick={() => {
                                recordRumClick('view_demo', { path });
                                window.open(`/live-demos/${path}`, '_blank');
                            }}>
                                Visit Demo
                            </Button>
                        )}
                        {demoDetails?.builderSpaceUrl && (
                            <Button key="builder-space-button" onClick={() => {
                                recordRumClick('view_builder_space', { path, builderSpaceUrl: demoDetails?.builderSpaceUrl });
                                window.open(demoDetails.builderSpaceUrl!, '_blank');
                            }}>
                                View in BuilderSpace
                            </Button>
                        )}
                    </SpaceBetween>
                    {demoDetails?.mainDescriptor ? (
                        <SpaceBetween key="space-overview-header" direction='vertical' size='xs'>
                            <Header key="overivew-header" variant='h3' >
                                Overview
                            </Header>
                            <p>{demoDetails?.mainDescriptor}</p>
                        </SpaceBetween>
                    ) : null}
                    {demoDetails?.features ? (
                        <SpaceBetween key="space-features-header" direction='vertical' size='xs'>
                            <Header key="features-header" variant='h3'>
                                Features
                            </Header>
                            <ul>
                                {demoDetails?.features.map((feature, index) => (
                                    <li key={index + 'feat'}>{feature}</li>
                                ))}
                            </ul>
                        </SpaceBetween>
                    ) : null}
                    {demoDetails?.useCases ? (
                        <SpaceBetween key="space-use-cases-header" direction='vertical' size='xs'>
                            <Header key="use-cases-header" variant='h3'>
                                Use Cases
                            </Header>
                            <ul>
                                {demoDetails?.useCases.map((useCase, index) => (
                                    <li key={index + 'usecase'}>{useCase}</li>
                                ))}
                            </ul>
                        </SpaceBetween>
                    ) : null}
                    {demoDetails?.sfdcTagCategory && demoDetails?.sfdcTagName ? (
                        <SpaceBetween key="space-sfdc-tags" direction='vertical' size='xs'>
                            <Header key="sfdc-tags-header" variant='h3'
                                info={
                                    <Link
                                        variant='info'
                                        href='/sfdc-tagging'
                                    >
                                        SFDC Tagging Help
                                    </Link>
                                }
                            >
                                SFDC Tag
                            </Header>
                            <div>
                                <strong>Category:</strong> <Badge color="blue">{demoDetails.sfdcTagCategory}</Badge>
                            </div>
                            <div>
                                <strong>Name: </strong>
                                <CopyToClipboard variant='inline'  copyButtonText={demoDetails.sfdcTagName} textToCopy={demoDetails.sfdcTagName} copyErrorText='Failed to Copy SFDC Tag' copySuccessText='Copied SFDC Tag' />
                            </div>
                        </SpaceBetween>
                    ) : null}
                    {demoDetails?.videoUrl ? (
                        <SpaceBetween key="space-video-header" direction='vertical' size='xs'>
                            <Header key="video-header" variant='h3' description="Watch a walkthrough of the demo, learn best practices and how to demo the solution to a customer.">
                                Video Walkthrough
                            </Header>
                            <iframe key="video-embed" onClick={() => {
                                recordRumClick('video_interaction', { path });
                            }} src={demoDetails?.videoUrl} title={name} width='100%' height='315' loading="lazy" style={{ border: 0, maxWidth: "560px" }} allowFullScreen>

                            </iframe>
                        </SpaceBetween>
                    ) : null}
                    {demoDetails?.repositoryUrl ? (
                        <SpaceBetween key="space-demo-repo" direction='vertical' size='xxs'>
                            <Header key="repo-header" variant='h3'>
                                Repository
                            </Header>
                            <SpaceBetween key="space-demo-repo-sub" direction='horizontal' size='xxs'>
                                {demoDetails?.repositoryUrl.includes('github.com') ? (
                                    <GitHubIcon key="gh-icon" color='primary' />
                                ) : null}
                                {demoDetails?.repositoryName ? (
                                    <strong key={'gh-repo-name'}>{demoDetails?.repositoryName}</strong>
                                ) : null}
                                <Link key="link-repo" onClick={() => {
                                }} external href={demoDetails?.repositoryUrl} target='_blank'>{demoDetails?.repositoryUrl}</Link>
                                {demoDetails?.repositoryNotes ? (
                                    <div key="repo-notes">{demoDetails?.repositoryNotes}</div>
                                ) : null}
                            </SpaceBetween>

                        </SpaceBetween>
                    ) : null}
                </SpaceBetween>
            </Container>
        </SpaceBetween>
    );
}
